var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item && _vm.item.variation
    ? _c(
        "article",
        {
          staticClass: "cmp cmp-product-thumb",
          attrs: { "data-testing": _vm.item.variation.id },
        },
        [
          _c(
            "div",
            { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
            [
              _c(
                "div",
                {
                  staticClass: "thumb-wishlist position-relative",
                  class: { "d-block": _vm.isVariationInWishList },
                },
                [
                  _c("add-to-wish-list", {
                    attrs: { "variation-id": _vm.item.variation.id },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "thumb-image" },
                [
                  _c(
                    "div",
                    { staticClass: "prop-1-1" },
                    [
                      _vm._t("item-image", function () {
                        return [
                          _c("category-image-carousel", {
                            ref: "categoryImageCarousel",
                            attrs: {
                              "image-urls-data": _vm._f("itemImages")(
                                _vm.item.images,
                                _vm.imageUrlAccessor
                              ),
                              alt: _vm._f("itemName")(_vm.item),
                              title: _vm._f("itemName")(_vm.item),
                              "item-url": _vm._f("itemURL")(
                                _vm.item,
                                _vm.urlWithVariationId
                              ),
                              "disable-carousel-on-mobile":
                                _vm.disableCarouselOnMobile,
                              "enable-carousel":
                                _vm.$ceres.config.item.enableImageCarousel,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("client-only", [
                    _vm.item && _vm.item.variation && _vm.energyIconImageUrl
                      ? _c("img", {
                          staticClass: "img-fluid",
                          style: {
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                            width: _vm.energyIconWidth,
                            height: "unset",
                          },
                          attrs: {
                            src: _vm.energyIconImageUrl,
                            alt:
                              _vm.$translate(
                                "GonserDT::Template.itemEnergyEfficiency"
                              ) + _vm.energyIconAlt,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showEnergyLightbox(
                                _vm.energyLightboxImageUrl
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("store-special", function () {
                return [
                  _vm.item.item.itemType === "set" || _vm.hasStoreSpecial
                    ? _c("item-store-special", {
                        attrs: {
                          "store-special": _vm.storeSpecial,
                          "recommended-retail-price": _vm.item.prices.rrp,
                          "variation-retail-price": _vm.item.prices.default,
                          "special-offer-price": _vm.item.prices.specialOffer,
                          "decimal-count": _vm.decimalCount,
                          "bundle-type":
                            _vm.item.variation.bundleType || _vm.storeSpecial,
                          "item-type": _vm.item.item.itemType,
                        },
                      })
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _vm._t("item-details", function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "thumb-content",
                      on: { click: _vm.seeItem },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "thumb-feedback d-flex align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "feedback-stars-average feedback-category-view own",
                                  attrs: { id: "feedback-stars-average" },
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _vm.item.item.feedbackDecimal > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "feedback-stars-overlay-wrap",
                                          style: { width: _vm.fillStars },
                                        },
                                        [_vm._m(1)]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showFeedbackCount,
                                      expression: "showFeedbackCount",
                                    },
                                  ],
                                  staticClass: "text-secondary ml-1",
                                  style: { transform: "translateY(-2px)" },
                                },
                                [
                                  _vm._v(
                                    "(" + _vm._s(_vm.safeFeedbackCount) + ")"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "tooltip", rawName: "v-tooltip" },
                              ],
                              staticClass: "thumb-availability",
                              attrs: {
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title:
                                  _vm.item.variation.availability.names.name,
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class:
                                    "availability " + _vm.getAvailabilityColor,
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa",
                                    class: {
                                      "fa-check-circle":
                                        _vm.item.variation.availability.id ===
                                          1 ||
                                        _vm.item.variation.availability.id ===
                                          3,
                                      "fa-times-circle":
                                        _vm.item.variation.availability.id ===
                                        10,
                                      "fa-circle":
                                        _vm.item.variation.availability.id !==
                                          1 &&
                                        _vm.item.variation.availability.id !==
                                          3 &&
                                        _vm.item.variation.availability.id < 7,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "thumb-title" },
                        [
                          _vm._v(_vm._s(_vm._f("itemName")(_vm.item))),
                          _vm._l(
                            _vm.item.groupedAttributes,
                            function (attribute) {
                              return _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")(
                                      "Ceres::Template.itemGroupedAttribute",
                                      attribute
                                    )
                                  )
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "thumb-meta mt-auto" },
                        [
                          _vm._t("before-prices"),
                          _vm._v(" "),
                          _c("div", { staticClass: "prices d-inline-block" }, [
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.price.value
                              ? _c("div", { staticClass: "price-view-port" }, [
                                  _c("span", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$translate(
                                            _vm.isRrpPriceType44
                                              ? "GonserDT::Template.itemInsteadUvp"
                                              : "GonserDT::Template.itemUvp",
                                            {
                                              price:
                                                _vm.$options.filters.currency(
                                                  _vm.item.prices.rrp.unitPrice
                                                    .value,
                                                  " "
                                                ),
                                            }
                                          )
                                        ) +
                                        "\n                              "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "price" },
                              [
                                _vm.itemGraduatedPriceisCheapestSorting
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  : _vm.itemGraduatedPricesalableVariationCount
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-uppercase text-dark price-currency",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.item.prices.default.currency
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm._f("specialOffer")(
                                              _vm.item.prices.default.unitPrice
                                                .value,
                                              _vm.item.prices,
                                              "unitPrice",
                                              "value"
                                            ),
                                            " "
                                          )
                                        ) + "\n              "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "thumb-additional d-inline-block h-100 float-right",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-end h-100" },
                                [
                                  _vm.isGonserBoxItem
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                            },
                                          ],
                                          staticClass:
                                            "thumb-gonser-box d-inline-block px-1",
                                          class: { "mb-1": _vm.showBasketBtn },
                                          attrs: {
                                            "data-toggle": "tooltip",
                                            "data-placement": "top",
                                            title: "GONSERBOX",
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "1.3em",
                                                height: "1.5em",
                                                preserveAspectRatio:
                                                  "xMidYMid meet",
                                                viewBox: "0 0 640 512",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#999999",
                                                  d: "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5c-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64L69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.showBasketBtn
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "thumb-item-preview d-inline-block",
                                          on: {
                                            "~mouseover": function ($event) {
                                              return _vm.$store.dispatch(
                                                "loadComponent",
                                                "item-preview-modal"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-link btn-sm text-primary pb-0 px-1",
                                              attrs: {
                                                href: "#",
                                                rel: "nofollow",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.setAndOpenPreviewItem(
                                                    $event
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "1.5em",
                                                    height: "1.5em",
                                                    preserveAspectRatio:
                                                      "xMidYMid meet",
                                                    viewBox: "0 0 16 16",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        fill: "currentColor",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M8 5.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "add-to-basket-wrapper text-center",
                                    },
                                    [
                                      _vm.showBasketBtn
                                        ? _c("add-to-basket", {
                                            attrs: {
                                              "variation-id":
                                                _vm.item.variation.id,
                                              "is-salable":
                                                !!_vm.item.filter &&
                                                _vm.item.filter.isSalable,
                                              "has-children":
                                                !!_vm.item.item &&
                                                _vm.item.item
                                                  .salableVariationCount > 1,
                                              "interval-quantity":
                                                _vm.item.variation
                                                  .intervalOrderQuantity || 1,
                                              "minimum-quantity":
                                                _vm.item.variation
                                                  .minimumOrderQuantity,
                                              "maximum-quantity":
                                                !!_vm.item.variation
                                                  .maximumOrderQuantity &&
                                                _vm.item.variation
                                                  .maximumOrderQuantity > 0
                                                  ? _vm.item.variation
                                                      .maximumOrderQuantity
                                                  : null,
                                              "order-properties":
                                                _vm.item.properties.filter(
                                                  function (prop) {
                                                    return prop.property
                                                      .isOderProperty
                                                  }
                                                ),
                                              "has-order-properties":
                                                _vm.item.hasOrderProperties,
                                              "has-required-order-property":
                                                _vm.item
                                                  .hasRequiredOrderProperty,
                                              "use-large-scale": false,
                                              "show-quantity": false,
                                              "is-wish-list": _vm.showBasketBtn,
                                              "item-url": _vm._f("itemURL")(
                                                _vm.item,
                                                _vm.urlWithVariationId
                                              ),
                                              "has-price": _vm._f(
                                                "hasItemDefaultPrice"
                                              )(_vm.item),
                                              "with-success-icon":
                                                _vm.withSuccessIcon,
                                              "item-type":
                                                _vm.item.item.itemType,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("after-prices"),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      )
    : _c("div", [_c("p", [_vm._v("Loading...")])])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-background clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-overlay clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }